import FormBody from "../../../../components/form-body";
import Input from "../../../../components/input";
import Label from "../../../../components/label";

export default function CharitySkeleton() {
  return (
    <div className="space-y-6 max-w-3xl py-8 text-left">
      <FormBody>
        <div className="mb-4">
          <Label htmlFor="name">Charity Name</Label>
          <Input
            id="name"
            name="name"
            type="text"
            aria-describedby="name-error"
            className="bg-gray-100 animate-pulse"
            disabled
          />
        </div>
        
        <div className="mb-4">
          <Label htmlFor="registrationNo">Registration Number</Label>
          <Input
            id="registrationNo"
            name="registrationNo"
            type="text"
            aria-describedby="registrationNo-error"
            className="bg-gray-100 animate-pulse"
            disabled
          />
        </div>

        <div className="mb-4">
          <Label htmlFor="website">Website</Label>
          <Input
            id="website"
            name="website"
            type="url"
            aria-describedby="website-error"
            className="bg-gray-100 animate-pulse"
            disabled
          />
        </div>

        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <Label htmlFor="income">Income</Label>
            <Input
              id="income"
              name="income"
              type="number"
              aria-describedby="income-error"
              className="bg-gray-100 animate-pulse"
              disabled
            />
          </div>
          <div>
            <Label htmlFor="expenditure">Expenditure</Label>
            <Input
              id="expenditure"
              name="expenditure"
              type="number"
              aria-describedby="expenditure-error"
              className="bg-gray-100 animate-pulse"
              disabled
            />
          </div>
        </div>

        <div className="mb-4">
          <Label htmlFor="aimsAndActivities">Aims and Activities</Label>
          <div className="h-20 w-full rounded bg-gray-100 animate-pulse"></div>
        </div>

        <div className="mb-4">
          <Label htmlFor="whatItDoes">What It Does</Label>
          <div className="h-20 w-full rounded bg-gray-100 animate-pulse"></div>
        </div>

        <div className="mb-4">
          <Label htmlFor="whoItHelps">Who It Helps</Label>
          <div className="h-20 w-full rounded bg-gray-100 animate-pulse"></div>
        </div>

        <div className="mb-4">
          <Label htmlFor="howItWorks">How It Works</Label>
          <div className="h-20 w-full rounded bg-gray-100 animate-pulse"></div>
        </div>
      </FormBody>
      <div className="mt-6 flex justify-end gap-4">
        <div className="h-10 w-24 rounded-lg bg-gray-100 animate-pulse"></div>
        <div className="h-10 w-32 rounded-lg bg-gray-100 animate-pulse"></div>
      </div>
    </div>
  );
}
